// VideoPlayer.js
import React, { useState, useRef, useEffect } from 'react';

const VideoPlayer = ({ videoList , currentVideoIndex,  setCurrentVideoIndex}) => {
  const videoRef = useRef();
console.log(videoList)
  useEffect(() => {
    const videoElement = videoRef.current;

    // Play the selected video when the currentVideoIndex changes
    videoElement.src = videoList[currentVideoIndex];
    videoElement.load();
    videoElement.play();

    // Play the next video when the current one ends
    const handleVideoEnd = () => {
      if (currentVideoIndex < videoList.length - 1) {
        setCurrentVideoIndex(currentVideoIndex + 1);
      }
    };

    // Attach event listener to the video element
    videoElement.addEventListener('ended', handleVideoEnd);


    // Clean up event listener when component unmounts
    return () => {
      videoElement.removeEventListener('ended', handleVideoEnd);
    };
  }, [currentVideoIndex, videoList, setCurrentVideoIndex]);

  return (
    <div>
      <video
      className='rounded-md w-full h-full'
        ref={videoRef}
        controls
        autoPlay
        src={videoList[currentVideoIndex]}
      />
    </div>
  );
};

export default VideoPlayer;
